import React from 'react';
import { Link } from 'react-router-dom';
import MobileFooter from '../../components/MobileFooter';

const MyAccount: React.FC = () => {
    return (
        <>
            {/* content */}
            <div className="container" id="main-content">
                <div className="p-3">
                    <Link to="/app/my-profile" className="dropdown-item text-center">
                        <figure className="avatar avatar-200 rounded-circle coverimg align-middle mb-3">
                            <img src={asset("assets/img/adminuiux/user-6.jpg")} alt="" />
                        </figure>
                        <h4 className="mb-1">DevUIUX</h4>
                        <p className="small"><i className="bi bi-trophy me-2"></i> 3 Achievements</p>
                    </Link>
                </div>
                <ul className="list-group list-group-flush bg-none">
                    <Link className="list-group-item list-group-item-action " to="/app/earning">
                        <span className="avatar avatar-30 rounded-circle me-1"><i className="bi bi-cash"></i></span> Earning
                    </Link>
                    <Link className="list-group-item list-group-item-action " to="/app/subscription">
                        <div className="row gx-3 gx-lg-4 align-items-center">
                            <div className="col">
                                <span className="avatar avatar-30 rounded-circle me-1"><i className="bi bi-gift"></i></span>
                                Subscription
                            </div>
                            <div className="col-auto">
                                <p className="small text-success">Upgrade</p>
                            </div>
                        </div>
                    </Link>
                    <Link className="list-group-item list-group-item-action " to="/app/statement">
                        <span className="avatar avatar-30 rounded-circle me-1"><i className="bi bi-clipboard-check"></i></span> Statement
                    </Link>
                    <Link className="list-group-item list-group-item-action " to="/app/account-settings">
                        <span className="avatar avatar-30 rounded-circle me-1"><i className="bi bi-gear"></i></span> Account Setting
                    </Link>
                    <Link className="list-group-item list-group-item-action  theme-red" to="/auth/login">
                        <span className="avatar avatar-30 rounded-circle me-1"><i className="bi bi-power"></i></span> Logout
                    </Link>
                </ul>
            </div>

            <MobileFooter />

        </>
    );
};

export default MyAccount;
